export default __webpack_public_path__ + "static/media/jobly.8e2255fc.png";